import React from 'react';
import { useSnackbar } from 'notistack';
import { useHistory } from 'react-router-dom';
import styled from '@emotion/styled/macro';
import { snackbarTypes } from 'redux/snackbar';
import { useTranslation } from 'react-i18next';
import { useActionListener } from 'hooks/actionListener/useActionListener';
import Button from 'components/Button';

const Action = styled(Button)`
  background-color: ${({ theme }) => theme.palette.common.white};
  color: ${({ theme }) => theme.palette.primary.main};

  &:hover {
    background-color: ${({ theme }) => theme.palette.grey[200]};
  }
`;

const SnackbarDisplayer = () => {

  const { t } = useTranslation(['snackbar', 'common']);

  const history = useHistory();

  const { closeSnackbar, enqueueSnackbar } = useSnackbar();

  useActionListener(snackbarTypes.create, (dispatch, action) => {
    const notification = action?.payload?.notification;

    if (!notification) {
      return;
    }

    const { translate, link, values, ...options } = notification.options;

    const message = translate ? t(notification.message, values) : notification.message;

    const follow = () => {
      closeSnackbar(notification.key);
      history.push(link.to);
    };

    enqueueSnackbar(message, {
      key: notification.key,
      onClick: () => closeSnackbar(notification.key),
      ...(link && { action: <Action size="small" onClick={follow}>{t(link.label)}</Action> }),
      ...options,
    });
  });

  return null;
};

export default SnackbarDisplayer;
